"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchBar = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InputBase = _interopRequireDefault(require("@material-ui/core/InputBase"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _styles = require("@material-ui/core/styles");

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    input: {
      width: '100%',
      height: 24
    },
    search: {
      border: "1px solid ".concat(theme.palette.action.disabled),
      borderRadius: 4,
      display: 'flex',
      alignItems: 'center',
      height: 36,
      paddingRight: 10,
      transition: 'all .3s',
      '&:hover': {
        border: "1px solid ".concat(theme.palette.text.primary)
      }
    },
    searchActive: {
      border: "2px solid ".concat(theme.palette.primary.main),
      '&:hover': {
        border: "2px solid ".concat(theme.palette.primary.main)
      }
    },
    icons: {
      margin: 8,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    icon: {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    searchIcon: {
      verticalAlign: 'middle'
    }
  };
});

var SearchBar = function SearchBar(_ref) {
  var placeholder = _ref.placeholder,
      onSubmit = _ref.onSubmit,
      size = _ref.size,
      value = _ref.value,
      onChange = _ref.onChange,
      clearSearch = _ref.clearSearch,
      goBackSearch = _ref.goBackSearch,
      onClickOustide = _ref.onClickOustide,
      showBackArrow = _ref.showBackArrow;
  var classes = useStyles();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      clicked = _useState2[0],
      setClicked = _useState2[1];

  var handleClassActive = function handleClassActive() {
    setClicked(!clicked);
  }; // Função padrao para realizar a busca de livros na BDS
  // const handleSearch = (value) => {
  //   if (value.length > 0) {
  //     history.push(`/books?query=${value}`)
  //   }
  // }


  return /*#__PURE__*/_react.default.createElement("form", {
    onBlur: onClickOustide,
    size: size,
    style: {
      width: (0, _utils.checkSize)(size)
    },
    className: clicked ? " ".concat(classes.search, " ").concat(classes.searchActive) : classes.search,
    onSubmit: onSubmit
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.icons
  }, value.length || showBackArrow ? /*#__PURE__*/_react.default.createElement(_ArrowBack.default, {
    onClick: goBackSearch,
    className: classes.icon
  }) : /*#__PURE__*/_react.default.createElement(_Search.default, {
    className: classes.searchIcon
  })), /*#__PURE__*/_react.default.createElement(_InputBase.default, {
    value: value,
    placeholder: placeholder,
    className: classes.input,
    onClick: handleClassActive,
    onBlur: handleClassActive,
    onChange: onChange
  }), value.length > 0 && /*#__PURE__*/_react.default.createElement(_Close.default, {
    onClick: clearSearch,
    className: classes.icon,
    style: {
      fontSize: 16
    }
  }));
};

exports.SearchBar = SearchBar;
SearchBar.propTypes = {
  /**
   * Escolhe o texto da barra de pesquisa
   */
  placeholder: _propTypes.default.string,

  /**
   * Função a ser executada ao realizar a busca do input
   */
  onSubmit: _propTypes.default.func,

  /**
   * Seleciona o tamanho do input
   */
  size: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', 'full']),

  /**
   * Valor do input
   */
  value: _propTypes.default.string,

  /**
   * Funcao ao mudar o valor
   */
  onChange: _propTypes.default.func,

  /**
   * Funcao para excluir a pesquisa
   */
  clearSearch: _propTypes.default.func.isRequired,

  /**
   * Funcao realizada ao clicar no botao de voltar
   */
  goBackSearch: _propTypes.default.func.isRequired,

  /**
   * Funcao realizada ao clicar fora do componente
   */
  onClickOustide: _propTypes.default.func,

  /**
   * Ativa Back Arrow mesmo sem preencher o campo de pesquisa
   */
  showBackArrow: _propTypes.default.bool
};
SearchBar.defaultProps = {
  placeholder: 'Buscar por título, autor ou ISBN',
  onSubmit: null,
  size: 'md',
  value: '',
  onChange: null,
  onClickOustide: null,
  showBackArrow: false
};
var _default = SearchBar;
exports.default = _default;